export enum ImageType {
  PROFILE_PIC = 'PROFILE_PIC',
  COVER_IMAGE = 'COVER_IMAGE',
  COMPANY_LOGO = 'COMPANY_LOGO',
}
